import React, { createContext, useContext, useState } from 'react';

const DEFAULT_PACKAGE = {
  packageTitle: 'Basic Package',
  packageAmount: '$45'
};

const PricingContext = createContext({
  activePricingTab: 1,
  selectedPackage: DEFAULT_PACKAGE,
  selectedPackageTitle: DEFAULT_PACKAGE.packageTitle,
  selectedPackageAmount: DEFAULT_PACKAGE.packageAmount,
  tmSignUpType: 1,
  setActivePricingTab: () => {},
  selectPackage: () => {},
  resetPackage: () => {},
});

export const PricingProvider = ({ children }) => {
  const [activePricingTab, setActivePricingTab] = useState(1);
  const [selectedPackage, setSelectedPackage] = useState(DEFAULT_PACKAGE);

  const tmSignUpType = activePricingTab;

  const handleSetTab = (tab) => {
    setActivePricingTab(tab);
  };

  const selectPackage = (packageTitle, packageAmount) => {
    setSelectedPackage({ packageTitle, packageAmount });
  };

  const resetPackage = () => {
    setSelectedPackage(DEFAULT_PACKAGE);
    setActivePricingTab(1);
  };

  return (
    <PricingContext.Provider
      value={{
        activePricingTab,
        selectedPackage,
        selectedPackageTitle: selectedPackage.packageTitle,
        selectedPackageAmount: selectedPackage.packageAmount,
        tmSignUpType,
        setActivePricingTab: handleSetTab,
        selectPackage,
        resetPackage,
      }}
    >
      {children}
    </PricingContext.Provider>
  );
};

export const usePricing = () => useContext(PricingContext);

export default PricingContext;
